// extracted by mini-css-extract-plugin
module.exports = {"tagsBlock":"styles_tagsBlock__lvVbj","title":"styles_title__BehH_","tagsList":"styles_tagsList__TBgCk","tag":"styles_tag__9QMpJ"};